<template>
    <div class="col-md-12 row pr-0">
        <div
            class="col-md-6"
            v-if="license.show.has_number"
        >
            <div class="form-group form-group-1">
                <label for="" class="form-label">License # {{ license.type }}</label>
                <input type="text" class="form-control" v-model="license.number">
            </div>
        </div>

        <div
            class="col-md-6 pr-0"
            v-if="license.show.has_expiration_date"
        >
            <div class="form-group form-group-1">
                <label for="" class="form-label">Expiration date</label>
                <date-picker
                    style="width: 100%;"
                    value-type="format"
                    format="YYYY-MM-DD"
                    v-model="license.expiration_date"
                ></date-picker>
            </div>
        </div>

        <div
            class="col-md-6"
            v-if="license.show.has_school_received"
        >
            <div class="form-group form-group-1">
                <label for="" class="form-label">School which you received your {{ license.type }} license</label>
                <input type="text" class="form-control" v-model="license.school_received">
            </div>
        </div>


        <div class="col-md-6 pr-0"
             v-if="license.show.has_experience"
        >
            <div class="form-group form-group-1">
                <label for="experience" class="form-label"> Year(s) Experience</label>
                <select
                    class="form-control custom-select"
                    name="experience"
                    id="experience"
                    v-model="license.experience"
                >
                    <option
                        class="custom-select"
                        v-for="i in 5"
                        :value="i"
                    >
                        {{ i }}
                    </option>
                </select>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "LicenseInput",
    props: {
        license: {
            type: Object,
            required: true
        },
    },

}

</script>

<style scoped>

</style>
